import { useContext } from 'react'
import styled from 'styled-components'
import { giphyLightGrey } from '@giphy/js-brand'
import CreationToolsTimeInput from './time-input'
import { CreationToolSourceFile } from '../types'
import { DuplicateWhiteIcon, FlipWhiteIcon, SendToBackWhiteIcon } from './icons'
import { CreationSourceEditorContext } from './source-editor/manager'
import CreationToolOutputType from '../types/output-type'

const LayerOptionsContainer = styled.div`
    display: flex;
    padding: 13px 15px 13px 15px;
`

const LayerOptionsMiddleContent = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    padding-left: 25px;
    padding-right: 25px;
`

const LayerOptionButton = styled.button`
    margin: 0;
    display: flex;
    align-items: center;
    color: ${giphyLightGrey};
    cursor: pointer;
    font-weight: bold;
    font-size: 15px;

    svg {
        height: 19px;
    }
`
type TimerOptions = {
    startTime: number
    endTime: number
    onTimeUpdate: (newStartTime: number, newEndTime: number) => void
}

type LayerOptionsMenuProps = {
    source: CreationToolSourceFile
    timerOptions: TimerOptions
    duplicate: () => void
    flip: () => void
    sendToBack: () => void
}

const LayerOptionsMenu = ({ source, timerOptions, duplicate, flip, sendToBack }: LayerOptionsMenuProps) => {
    const { outputType } = useContext(CreationSourceEditorContext)
    const { startTime, endTime, onTimeUpdate } = timerOptions

    const supportsTimer = outputType === CreationToolOutputType.Gif || outputType === CreationToolOutputType.Sticker

    return (
        <LayerOptionsContainer>
            {supportsTimer && (
                <CreationToolsTimeInput
                    {...{
                        value: startTime,
                        min: 0,
                        max: endTime - 0.1,
                        onUpdate: (newTime) => onTimeUpdate(newTime, endTime),
                    }}
                />
            )}
            <LayerOptionsMiddleContent>
                <LayerOptionButton onClick={duplicate}>
                    <DuplicateWhiteIcon />
                    Duplicate
                </LayerOptionButton>
                <LayerOptionButton onClick={flip}>
                    <FlipWhiteIcon />
                    Flip
                </LayerOptionButton>
                <LayerOptionButton onClick={sendToBack}>
                    <SendToBackWhiteIcon />
                    Send to Back
                </LayerOptionButton>
            </LayerOptionsMiddleContent>
            {supportsTimer && (
                <CreationToolsTimeInput
                    {...{
                        value: endTime,
                        min: startTime + 0.1,
                        max: source.duration,
                        onUpdate: (newTime) => onTimeUpdate(startTime, newTime),
                    }}
                />
            )}
        </LayerOptionsContainer>
    )
}

export default LayerOptionsMenu
